function SunIcon() {
  return (
    <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
      <circle cx={12} cy={12} r={4} />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

interface Props {
  dark: boolean;
  onToggle: () => void;
  borderColor: string;
  color: string;
}

export default function DarkModeToggle({ dark, onToggle, borderColor, color }: Props) {
  return (
    <button
      onClick={onToggle}
      aria-label="Toggle dark mode"
      style={{
        position: 'fixed',
        // the viewport is viewport-fit=cover, so keep clear of the notch
        top: 'calc(20px + env(safe-area-inset-top, 0px))',
        right: 'calc(20px + env(safe-area-inset-right, 0px))',
        width: 44, height: 44,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        border: `1px solid ${borderColor}`, borderRadius: '50%',
        background: 'transparent', color, cursor: 'pointer',
        transition: 'border-color .35s ease, color .35s ease',
        zIndex: 10,
      }}
    >
      {dark ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}
